import { StatsForNerdsStore } from './store';
import { styles } from './styles';
import * as formatters from './formatters';
const attributesMap = {
    deviceInfo: formatters.deviceInfoFormatter,
    sdkVersion: formatters.defaultFormatter,
    playerName: formatters.defaultFormatter,
    playerVersion: formatters.defaultFormatter,
    capabilities: formatters.arrayFormatter,
    psid: formatters.defaultFormatter,
    assetType: formatters.defaultFormatter,
    streamType: formatters.defaultFormatter,
    videoResolution: formatters.videoResolutionFormatter,
    playbackState: formatters.defaultFormatter,
    duration: formatters.defaultFormatter,
    position: formatters.unixTimeFormatter,
    bufferLength: formatters.bufferLengthFormatter,
    bitrate: formatters.bpsFormatter,
    startupTime: formatters.defaultFormatter,
    latency: formatters.defaultFormatter,
    selectedAudioTrack: formatters.mediaTrackFormatter,
    selectedSubtitlesTrack: formatters.mediaTrackFormatter,
};
const createStatsEntry = (key, statsData) => {
    if (!attributesMap[key]) {
        return null;
    }
    const value = statsData[key];
    const formatter = attributesMap[key];
    const formattedValue = formatter(value);
    return {
        key,
        value,
        formattedValue,
    };
};
export const getDisplayableEntries = (statsData) => {
    const keys = Object.keys(statsData);
    return keys
        .filter((key) => key !== 'statsForNerdsVisible')
        .map((key) => createStatsEntry(key, statsData))
        .filter((entry) => entry !== null);
};
export { StatsForNerdsStore, styles, };
